import { render } from "./ListaProdutos.vue?vue&type=template&id=40537762&scoped=true"
import script from "./ListaProdutos.vue?vue&type=script&lang=js"
export * from "./ListaProdutos.vue?vue&type=script&lang=js"

import "./ListaProdutos.vue?vue&type=style&index=0&id=40537762&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\sensualle\\sensualle - pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40537762"]])

export default __exports__